var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "box" },
    [
      _vm.ok
        ? _c("i", {
            staticClass:
              "fas fa-check-circle fa-lg has-text-success is-pulled-right",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Mi cuenta")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Cambiar clave")]),
      _vm._v(" "),
      _c("p", {}, [
        _vm._v(
          " Ingrese su clave actual y la que desee utilizar a partir de este momento"
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("b-message", { attrs: { size: "is-small" } }),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "notification is-warning" }, [
            _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-5-desktop is-8-tablet" }, [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Clave actual")]),
              _vm._v(" "),
              _c("b-input", {
                attrs: {
                  type: "password",
                  placeholder: "Su contraseña actual",
                  "password-reveal": "",
                },
                model: {
                  value: _vm.model.clave_actual,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "clave_actual", $$v)
                  },
                  expression: "model.clave_actual",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Clave Nueva")]),
              _vm._v(" "),
              _c("b-input", {
                attrs: {
                  type: "password",
                  placeholder: "Su nueva contraseña",
                  "password-reveal": "",
                },
                model: {
                  value: _vm.model.clave_nueva,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "clave_nueva", $$v)
                  },
                  expression: "model.clave_nueva",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Repita la nueva clave"),
              ]),
              _vm._v(" "),
              _c("b-input", {
                attrs: {
                  type: "password",
                  placeholder: "Reescriba su nueva conraseña",
                  "password-reveal": "",
                },
                model: {
                  value: _vm.model.clave_control,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "clave_control", $$v)
                  },
                  expression: "model.clave_control",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit()
              },
            },
          },
          [_vm._v("\n       Guardar")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }